import StatsAPI from "@/src/api/StatsAPI";

import type { Query } from "@/src/api/BaseAPI";
import type {
  InstitutionSessionsByDayResponse,
  InstitutionSessionsResponse,
  InstitutionViewsResponse,
} from "@/src/api/StatsAPI.types";
import type { AnalyticsPeriod } from "@/src/hooks/usePeriodFilter";

export function institutionSessionsByDayQuery(
  projectSlug: string,
  institutionUuid: string,
  { startDate, endDate }: AnalyticsPeriod,
): Query<InstitutionSessionsByDayResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getInstitutionSessionByDay,
    params: [
      {
        institutionUuid,
        projectSlug,
        periodStart: startDate,
        periodEnd: endDate,
      },
    ],
    options: { keepPreviousData: true },
  });
}

export function institutionSessionsQuery(
  projectSlug: string,
  institutionUuid: string,
): Query<InstitutionSessionsResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getInstitutionSessions,
    params: [{ projectSlug, institutionUuid }],
  });
}

export function institutionViewsQuery(
  projectSlug: string,
  institutionUuid: string,
): Query<InstitutionViewsResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getInstitutionViews,
    params: [{ projectSlug, institutionUuid }],
  });
}
